export default __webpack_public_path__ + "assets/images/c4b0dc2110b7ee1414036661f2d2b560.svg";